import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Feedback } from "../models/feedback";

@Injectable({
    providedIn: "root"
})
export class FeedbackService {

    private createHeader() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return httpOptions;
    }

    constructor(private httpClient: HttpClient) { }

    postFeedback(feedback: Feedback) {
        const cloneFeedback = JSON.parse(JSON.stringify(feedback));
        
        cloneFeedback.ToolComments = cloneFeedback.ToolComments?.replace(/./g, x => x);
        cloneFeedback.ProcessComments = cloneFeedback.ProcessComments?.replace(/./g, x => x);
        return this.httpClient.post<Feedback>(`${environment.ApiEndpoint}/Feedback/CreateFeedback`, cloneFeedback, this.createHeader());
    }
}